import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';


@Component({
})
export default class SBImageStep extends Mixins(SBComponentVue) {
    @Prop({
        type: String,
        default: "",
    })
    image!: string;

    @Prop({
        type: String,
        default: "",
    })
    title!: string;

}
